module.exports = __webpack_public_path__ + "static/media/logo.e73485a6.svg";